export enum TokenType {
  EXPO = 'EXPO',
  FIREBASE = 'FIREBASE',
}
